import I18n from '../../config/i18n';

import { stringArrayToObject } from '../../utils/array';

import { loadAdmins, loadEditors, loadGuests } from '../../services/CollaboratorService';
import { enableUser, disableUser } from '../../services/DatabaseService';
import { cancelInvite } from '../../services/AccountService';
import { actionCreators as toastActions } from '../Toasts/actions';

export const actions = stringArrayToObject([
  'CLEAR',
  'LOAD_ADMINS_START',
  'LOAD_ADMINS_SUCCESS',
  'LOAD_ADMINS_FAIL',
  'LOAD_EDITORS_START',
  'LOAD_EDITORS_SUCCESS',
  'LOAD_EDITORS_FAIL',
  'LOAD_GUESTS_START',
  'LOAD_GUESTS_SUCCESS',
  'LOAD_GUESTS_FAIL',
  'CANCEL_START',
  'CANCEL_SUCCESS',
  'CANCEL_FAIL',
  'ENABLE_COLLABORATOR',
  'DISABLE_COLLABORATOR',
], '@COLLABORATORS');

const privateActionCreators = {
  loadAdminsStart(page, { search }) {
    return {
      type: actions.LOAD_ADMINS_START,
      payload: { page, search },
    };
  },
  loadAdminsSuccess({
    page, totalPages, admins, total, limit,
  }) {
    return {
      type: actions.LOAD_ADMINS_SUCCESS,
      payload: {
        page, totalPages, admins, total, limit,
      },
    };
  },
  loadAdminsFail(error) {
    return {
      type: actions.LOAD_ADMINS_FAIL,
      payload: { error },
    };
  },
  loadEditorsStart(page, { search }) {
    return {
      type: actions.LOAD_EDITORS_START,
      payload: { page, search },
    };
  },
  loadEditorsSuccess({
    page, totalPages, editors, total, limit,
  }) {
    return {
      type: actions.LOAD_EDITORS_SUCCESS,
      payload: {
        page, totalPages, editors, total, limit,
      },
    };
  },
  loadEditorsFail(error) {
    return {
      type: actions.LOAD_EDITORS_FAIL,
      payload: { error },
    };
  },
  loadGuestsStart(page, { search }) {
    return {
      type: actions.LOAD_GUESTS_START,
      payload: { page, search },
    };
  },
  loadGuestsSuccess({
    page, totalPages, guests, total, limit,
  }) {
    return {
      type: actions.LOAD_GUESTS_SUCCESS,
      payload: {
        page, totalPages, guests, total, limit,
      },
    };
  },
  loadGuestsFail(error) {
    return {
      type: actions.LOAD_GUESTS_FAIL,
      payload: { error },
    };
  },
  cancelStart(id) {
    return {
      type: actions.CANCEL_START,
      payload: { id },
    };
  },
  cancelSuccess(id) {
    return {
      type: actions.CANCEL_SUCCESS,
      payload: { id },
    };
  },
  cancelFail(id, error) {
    return {
      type: actions.CANCEL_FAIL,
      payload: { id, error },
    };
  },
};

export const actionCreators = {
  clear() {
    return {
      type: actions.CLEAR,
    };
  },
  loadAdmins(page = 1, options = {}) {
    return async (dispatch) => {
      dispatch(privateActionCreators.loadAdminsStart(page, options));
      const response = await loadAdmins(page, options);
      if (response.ok) {
        dispatch(privateActionCreators.loadAdminsSuccess(response));
      } else {
        dispatch(privateActionCreators.loadAdminsFail(response.error));
      }
    };
  },
  loadEditors(page = 1, options = {}) {
    return async (dispatch) => {
      dispatch(privateActionCreators.loadEditorsStart(page, options));
      const response = await loadEditors(page, options);
      if (response.ok) {
        dispatch(privateActionCreators.loadEditorsSuccess(response));
      } else {
        dispatch(privateActionCreators.loadEditorsFail(response.error));
      }
    };
  },
  loadGuests(page = 1, options = {}) {
    return async (dispatch) => {
      dispatch(privateActionCreators.loadGuestsStart(page, options));
      const response = await loadGuests(page, options);
      if (response.ok) {
        dispatch(privateActionCreators.loadGuestsSuccess(response));
      } else {
        dispatch(privateActionCreators.loadGuestsFail(response.error));
      }
    };
  },
  cancelInvite(id) {
    return async (dispatch) => {
      dispatch(privateActionCreators.cancelStart(id));
      const response = await cancelInvite(id);
      if (response.ok) {
        dispatch(privateActionCreators.cancelSuccess(id));
        dispatch(toastActions.addToast({
          type: 'success',
          message: I18n.t('screens.collaborators.invites.messages.removed'),
        }));
      } else {
        dispatch(privateActionCreators.cancelFail(id, response.error));
        dispatch(toastActions.addToast({
          type: 'error',
          message: I18n.t('screens.collaborators.invites.errors.notRemoved'),
        }));
      }
    };
  },
  resendInvite(id) {
    // TODO finish action
    return async (dispatch) => {};
  },
  loadCollaborators() {
    return async (dispatch) => {
      dispatch(actionCreators.clear());
      dispatch(actionCreators.loadAdmins());
      dispatch(actionCreators.loadEditors());
      dispatch(actionCreators.loadGuests());
    };
  },
  enableCollaborator(id) {
    return async (dispatch) => {
      dispatch({ type: actions.ENABLE_COLLABORATOR });
      const response = await enableUser(id, 'collaborators');
      if (response.ok) {
        dispatch(actionCreators.loadCollaborators());
        dispatch(toastActions.addToast({
          type: 'success',
          message: I18n.t('screens.collaborators.home.messages.enableSuccess'),
        }));
      } else {
        dispatch(toastActions.addToast({
          type: 'error',
          message: I18n.t('screens.collaborators.home.messages.failure'),
        }));
      }
    };
  },
  disableCollaborator(id) {
    return async (dispatch) => {
      dispatch({ type: actions.DISABLE_COLLABORATOR });
      const response = await disableUser(id, 'collaborators');
      if (response.ok) {
        dispatch(actionCreators.loadCollaborators());
        dispatch(toastActions.addToast({
          type: 'success',
          message: I18n.t('screens.collaborators.home.messages.disableSuccess'),
        }));
      } else {
        dispatch(toastActions.addToast({
          type: 'error',
          message: I18n.t('screens.collaborators.home.messages.failure'),
        }));
      }
    };
  },
};



// WEBPACK FOOTER //
// ./src/redux/Collaborators/actions.js